export { default } from './TravelGraphsHeading';
